import { ReactComponent as GiftMessageIcon } from '@svgs/keyline/gift-message.svg'
import Translations from '@helpers/translations'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import styles from './styles.module.scss'
import { useState } from 'react'

type GiftMessageButtonProps = {
  setShowGiftMessageModal: (arg: boolean) => void
  hasGiftMessage: boolean
  updateGiftMessage: (arg: string) => void
}

const GiftMessageButton = ({
  setShowGiftMessageModal,
  hasGiftMessage,
  updateGiftMessage
}: GiftMessageButtonProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleUpdate = async (msg: string) => {
    setIsSubmitting(true)
    await updateGiftMessage(msg)
    setIsSubmitting(false)
  }

  if (isSubmitting) {
    return (
      <div className={styles.giftMessageWrapper}>
        <GiftMessageIcon
          className="GiftMessageIcon"
          aria-label="gift message icon"
          width="33"
          height="26"
        />
        Loading...
      </div>
    )
  }
  if (hasGiftMessage) {
    return (
      <div className={styles.giftMessageWrapper}>
        <GiftMessageIcon
          className="GiftMessageIcon"
          aria-label="gift message icon"
          width="33"
          height="26"
        />
        {Translations.localise('pages.cart.added-gift-message')}

        <div className={styles.giftMessageButtons}>
          <ButtonMinimal onClick={() => setShowGiftMessageModal(true)}>
            Edit
          </ButtonMinimal>
          <ButtonMinimal onClick={() => handleUpdate('')}>Remove</ButtonMinimal>
        </div>
      </div>
    )
  }
  return (
    <button
      className={`${styles.giftMessageWrapper} ${styles.giftMessageWrapper__button}`}
      onClick={() => setShowGiftMessageModal(true)}
    >
      <GiftMessageIcon
        className="GiftMessageIcon"
        aria-label="gift message icon"
      />
      {Translations.localise('pages.cart.add-gift-message')}
    </button>
  )
}

export default GiftMessageButton
